import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import RTL from '../src/helpers/RTL';
import {PatientsProvider} from './context/patient_context';
import {BrowserRouter as Router} from 'react-router-dom';
import {queryClient} from 'react-query/queryClient';
import {QueryClientProvider} from '@tanstack/react-query';
import {AuthContextProvider} from "./context/auth/AuthContext";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

// import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";

if ('serviceWorker' in navigator) {
    window.addEventListener('load', function () {
        navigator.serviceWorker.register('/service-worker.js').then(function (registration) {
            console.log('ServiceWorker registration successful with scope: ', registration.scope);
        }, function (err) {
            console.log('ServiceWorker registration failed: ', err);
        });
    });
}

const theme = createTheme({
    typography: {
        fontFamily: 'dana',
    },
    palette: {
        primary: {
            main: '#753cbe',
        },
        secondary: {
            main: '#1fb9ee',
        },
    },
    direction: 'rtl',
});

// Sentry.init({
//     dsn: "https://examplePublicKey@o0.ingest.sentry.io/0",
//     integrations: [new BrowserTracing()],
//
//     // We recommend adjusting this value in production, or using tracesSampler
//     // for finer control
//     tracesSampleRate: 1.0,
// });
//I DELETED DIR="RTL" IN INDEX.HTML SO IT DOES NOT WORK(because of chart)
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <Router>
        <AuthContextProvider>
            <PatientsProvider>
                <React.StrictMode>
                    <QueryClientProvider client={queryClient}>
                        {/*<ReactQueryDevtools/>*/}
                        <ThemeProvider theme={theme}>
                            <RTL>
                                <App/>
                            </RTL>
                        </ThemeProvider>
                    </QueryClientProvider>
                </React.StrictMode>
            </PatientsProvider>
        </AuthContextProvider>
    </Router>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
